import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"




export default /*@__PURE__*/_defineComponent({
  __name: 'CustomBadge',
  props: {
  bgColor: {
    type: String,
    required: true,
  },
  text: {
    type: String,
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['custom-badge px-2 py-1 rounded text-black ml-2', __props.bgColor])
  }, _toDisplayString(__props.text), 3))
}
}

})